import { gql } from '@apollo/client';

const INSERT_ANSWERS = gql`
mutation insertAnswers($userEmail: String!,$id_option:Int!,$free_response:String!) {
  insert_answers_one(object:{
    id_option:$id_option,
    id_question:1,
    user_email:$userEmail,
    text:$free_response
    
  }){
    id,
    user_email
  }
}`

const GET_QUESTIONS = gql`
query getQuestions{
  question_by_pk (id:1 ){
    question,
    options{
      id,
      description
    }
  }
}`

const SUBS_MEMBERSHIP = gql`
subscription getUserMembershipType($userEmail: String!) {
user_account(
  where: {email: {_eq: $userEmail}}
) {
  email
  membership_type
  due_date
}
}`

const SUBS_PAYMENTS = gql`
subscription getPayments($userEmail: String!,$limitPayments:Int!) {
  payments(where: {email: {_eq: $userEmail}}, 
    order_by: {created_at: desc},
  	limit:$limitPayments) {
    created_at
    email
    gross_amount
    start_date
    end_date
    payment_status
    membership {
      name,
      type
    }
  }
}`

const GET_MEMBERSHIP = gql`
  query getMembership{
    membership (where:{public:{_eq:true}},order_by:{price:asc }){
      price,
      name,
      type,
      active,
      payment_interval,
      stripe_price_id,
      membership_features{
        feature{
          description
        }
      }
    }
  }
`;

export default { INSERT_ANSWERS, GET_QUESTIONS, SUBS_MEMBERSHIP, GET_MEMBERSHIP, SUBS_PAYMENTS }